import React, { useEffect, useState } from "react";

export const isTreatmentRunning = (dose) =>
    Boolean(dose?.open_time) && !dose?.close_time && dose?.status !== "Completed";

// Seconds since `startTime`, updated every second.
const useElapsedSeconds = (startTime) => {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);

    const start = new Date(startTime).getTime();
    if (isNaN(start)) return 0;
    return Math.max(0, Math.floor((now - start) / 1000)); // clamp in case the device clock is behind the server
};

export const formatElapsed = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const mm = String(minutes).padStart(2, "0");
    const ss = String(seconds).padStart(2, "0");
    return hours > 0 ? `${hours}:${mm}:${ss}` : `${mm}:${ss}`;
};

const barStyles = `
@keyframes tpt-progress-slide {
    0% { left: -35%; }
    100% { left: 100%; }
}
.tpt-progress-runner {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 35%;
    border-radius: 9999px;
    animation: tpt-progress-slide 1.6s ease-in-out infinite;
}
`;

// Live running timer for a treatment in progress.
// compact: small text-only version for table cells; otherwise a full-width animated bar with the timer.
const TreatmentElapsedTimer = ({ startTime, compact = false }) => {
    const elapsed = formatElapsed(useElapsedSeconds(startTime));

    if (compact) {
        return (
            <div className="flex flex-row items-center gap-1 font-bold text-yellow-600">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-yellow-500 animate-pulse" />
                {elapsed}
            </div>
        );
    }

    return (
        <div className="w-full">
            <style>{barStyles}</style>
            <div className="flex flex-row justify-between items-center text-xs mb-1">
                <span className="flex flex-row items-center gap-1.5 font-semibold text-yellow-700">
                    <span className="inline-block w-2 h-2 rounded-full bg-yellow-500 animate-pulse" />
                    Treatment running
                </span>
                <span className="font-mono font-bold text-sm">{elapsed}</span>
            </div>
            <div className="relative w-full h-2.5 bg-yellow-100 rounded-full overflow-hidden">
                <div className="tpt-progress-runner bg-yellow-500" />
            </div>
        </div>
    );
};

export default TreatmentElapsedTimer;
